import moment from 'moment';

/**
* Display date format
* @param date date using this format 2020-12-31
*/
export const getOfferDateFormat = (date: string) =>
 moment(date)
   .format('MMMM Do, YYYY')
   .replace(',', '');

/*
 * Returns the text from a HTML string
 *
 * @param {html} String The html string
 */
export const sanitizeHtmlText = (text: string) => {
    if (!text) return '';
    return text
      .replace(/&quot;/g, '"')
      .replace(/&iacute;/g, 'í')
      .replace(/&mdash;/g, '—')
      .replace(/&reg;/g, '®')
      .replace(/&apos;/g, "'")
      .replace(/&acute;/g, '´')
      .replace(/&trade;/g, '™')
      .replace(/&copy;/g, '©')
      .replace(/&amp;/g, '&')
      .replace(/&rsquo;/g, '’');
  };

  export const sanitizeLocaleType = (locale?: string) => {
    if (!locale) return "";
    switch(locale.toLowerCase()){
        case "daa":
            return "Local"
        default:
            return locale;
    }
  }

  /**
 * Give format to the Phone number
 * @param phone Phone number
 */
export const stringToPhoneFormat = (phone: string) =>
phone?.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
